import { useEffect } from "react";
import { SEMINAR } from "@/seminars";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useLanding } from "@/context/LandingContext";
import { RegistrationForm } from "./RegistrationForm";
import { ClosedNotice } from "./RegistrationClosed";
import { LanguageSwitch } from "./SiteNav";

export function RegistrationModal() {
  const { t, registerOpen, setRegisterOpen, lenisRef } = useLanding();

  useEffect(() => {
    document.body.classList.toggle("reg-modal-open", registerOpen);
    const lenis = lenisRef.current;
    if (registerOpen) lenis?.stop();
    else lenis?.start();
    return () => {
      document.body.classList.remove("reg-modal-open");
      lenis?.start();
    };
  }, [registerOpen, lenisRef]);

  return (
    <Dialog open={registerOpen} onOpenChange={setRegisterOpen}>
      <DialogContent className={`reg-modal theme-${SEMINAR.theme || SEMINAR.id}`} data-lenis-prevent="" data-testid="registration-modal">
        <DialogTitle className="sr-only">{t.register.eyebrow}</DialogTitle>
        <DialogDescription className="sr-only">{t.register.lead}</DialogDescription>
        <div className="reg-modal-bar" data-testid="registration-modal-bar">
          <span className="reg-modal-kicker">{SEMINAR.registrationClosed ? t.closed.badge : t.register.eyebrow}</span>
          <LanguageSwitch sfx="-modal" />
        </div>
        {SEMINAR.registrationClosed ? <ClosedNotice sfx="-modal" /> : <RegistrationForm scope="modal" />}
      </DialogContent>
    </Dialog>
  );
}
